import React from "react";
import { motion } from "framer-motion";

// components
import SkillSets from "./SkillSets";
import TechStack from "./TechStack";
import ToolStack from "./ToolStack";

const skillSetsVariants = {
	initial: {
		opacity: 0,
	},
	animate: {
		opacity: 1,
	},
	exit: {
		opacity: 0,
	},
	transition: {
		duration: 1,
		delay: 2,
	},
};

const SkillSetSection = () => {
	return (
		<>
			<motion.div
				variants={skillSetsVariants}
				{...skillSetsVariants}
				className="mb-5 p-5 flex flex-col justify-center">
				<TechStack />
				<hr className="my-10 border-green-800" />
				<ToolStack />
			</motion.div>
		</>
	);
};

export default SkillSetSection;
